import { Table, Tag } from "antd";

import ContextMenu from "@/components/containers/ContextMenu";
import EmployeeProfile from "@/components/cards/EmployeeProfile";
import CopyableText from "@/components/ui/СopyableText";
import CustomLink from "@/components/ui/CustomLink";
import CollapsibleList from "@/components/ui/CollapsibleList";

import routes from "@/routes";

// Таблица пользователей
const UsersTable = ({
  data,
  pagination,
  loading,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "Логин",
      dataIndex: "email",
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.email.localeCompare(b.email),
        multiple: 1,
      },
      render: (email, user) => (
        <CopyableText text={email} hoverable>
          <CustomLink
            to={routes.administration.userDetail(user.uuid)}
            color="#303030"
          >
            {email}
          </CustomLink>
        </CopyableText>
      ),
    },
    {
      title: "Роль",
      width: 200,
      dataIndex: "role",
      render: (role) => <Tag>{role}</Tag>,
    },
    {
      title: "Сотрудник",
      dataIndex: "employee",
      render: (employee) => (employee ? <EmployeeProfile {...employee} /> : ""),

      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "Рабочие группы",
      dataIndex: "units",
      render: (units) =>
        units ? (
          <CollapsibleList items={units.map((u) => u.name)} count={3} />
        ) : (
          ""
        ),

      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "",
      width: 48,
      align: "center",
      fixed: "right",
      key: "actions",
      render: (_, item) => (
        <ContextMenu
          vertical
          onEdit={() => onEditItem(item)}
          onDelete={() => onDeleteItem(item)}
        />
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
      rowClassName="top-align"
    />
  );
};

export default UsersTable;
